import { render, staticRenderFns } from "./matchModal.vue?vue&type=template&id=4b1456c0&"
import script from "./matchModal.vue?vue&type=script&lang=js&"
export * from "./matchModal.vue?vue&type=script&lang=js&"
import style0 from "./matchModal.vue?vue&type=style&index=0&id=4b1456c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports